/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  assertIsInstructionWithAccounts,
  containsBytes,
  fixEncoderSize,
  getBytesEncoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_ACCOUNT,
  SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_INSTRUCTION,
  SOLANA_ERROR__PROGRAM_CLIENTS__UNRECOGNIZED_INSTRUCTION_TYPE,
  SolanaError,
  type Address,
  type ClientWithPayer,
  type ClientWithRpc,
  type ClientWithTransactionPlanning,
  type ClientWithTransactionSending,
  type GetAccountInfoApi,
  type GetMultipleAccountsApi,
  type Instruction,
  type InstructionWithData,
  type ReadonlyUint8Array,
} from '@solana/kit';
import {
  addSelfFetchFunctions,
  addSelfPlanAndSendFunctions,
  type SelfFetchFunctions,
  type SelfPlanAndSendFunctions,
} from '@solana/program-client-core';
import {
  getCosignerConfigCodec,
  type CosignerConfig,
  type CosignerConfigArgs,
} from '../accounts';
import {
  getAddCosignerInstructionAsync,
  getInitializeConfigInstructionAsync,
  getRemoveCosignerInstructionAsync,
  getSetAuthorityInstructionAsync,
  parseAddCosignerInstruction,
  parseInitializeConfigInstruction,
  parseRemoveCosignerInstruction,
  parseSetAuthorityInstruction,
  type AddCosignerAsyncInput,
  type InitializeConfigAsyncInput,
  type ParsedAddCosignerInstruction,
  type ParsedInitializeConfigInstruction,
  type ParsedRemoveCosignerInstruction,
  type ParsedSetAuthorityInstruction,
  type RemoveCosignerAsyncInput,
  type SetAuthorityAsyncInput,
} from '../instructions';

export const DOPPLER_LAUNCH_HOOK_V1_PROGRAM_ADDRESS =
  'HVsPNZh98TgChUXHwKrUG47SUqvGQHxUy5wZwcQLFD4i' as Address<'HVsPNZh98TgChUXHwKrUG47SUqvGQHxUy5wZwcQLFD4i'>;

export enum DopplerLaunchHookV1Account {
  CosignerConfig,
}

export function identifyDopplerLaunchHookV1Account(
  account: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): DopplerLaunchHookV1Account {
  const data = 'data' in account ? account.data : account;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([133, 227, 177, 74, 145, 74, 247, 183]),
      ),
      0,
    )
  ) {
    return DopplerLaunchHookV1Account.CosignerConfig;
  }
  throw new SolanaError(
    SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_ACCOUNT,
    { accountData: data, programName: 'dopplerLaunchHookV1' },
  );
}

export enum DopplerLaunchHookV1Instruction {
  AddCosigner,
  InitializeConfig,
  RemoveCosigner,
  SetAuthority,
}

export function identifyDopplerLaunchHookV1Instruction(
  instruction: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): DopplerLaunchHookV1Instruction {
  const data = 'data' in instruction ? instruction.data : instruction;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([17, 34, 183, 119, 202, 255, 218, 233]),
      ),
      0,
    )
  ) {
    return DopplerLaunchHookV1Instruction.AddCosigner;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([208, 127, 21, 1, 194, 190, 196, 70]),
      ),
      0,
    )
  ) {
    return DopplerLaunchHookV1Instruction.InitializeConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([174, 11, 171, 252, 179, 99, 220, 27]),
      ),
      0,
    )
  ) {
    return DopplerLaunchHookV1Instruction.RemoveCosigner;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([133, 250, 37, 21, 110, 163, 26, 121]),
      ),
      0,
    )
  ) {
    return DopplerLaunchHookV1Instruction.SetAuthority;
  }
  throw new SolanaError(
    SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_INSTRUCTION,
    { instructionData: data, programName: 'dopplerLaunchHookV1' },
  );
}

export type ParsedDopplerLaunchHookV1Instruction<
  TProgram extends string = 'HVsPNZh98TgChUXHwKrUG47SUqvGQHxUy5wZwcQLFD4i',
> =
  | ({
      instructionType: DopplerLaunchHookV1Instruction.AddCosigner;
    } & ParsedAddCosignerInstruction<TProgram>)
  | ({
      instructionType: DopplerLaunchHookV1Instruction.InitializeConfig;
    } & ParsedInitializeConfigInstruction<TProgram>)
  | ({
      instructionType: DopplerLaunchHookV1Instruction.RemoveCosigner;
    } & ParsedRemoveCosignerInstruction<TProgram>)
  | ({
      instructionType: DopplerLaunchHookV1Instruction.SetAuthority;
    } & ParsedSetAuthorityInstruction<TProgram>);

export function parseDopplerLaunchHookV1Instruction<TProgram extends string>(
  instruction: Instruction<TProgram> & InstructionWithData<ReadonlyUint8Array>,
): ParsedDopplerLaunchHookV1Instruction<TProgram> {
  const instructionType = identifyDopplerLaunchHookV1Instruction(instruction);
  switch (instructionType) {
    case DopplerLaunchHookV1Instruction.AddCosigner: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: DopplerLaunchHookV1Instruction.AddCosigner,
        ...parseAddCosignerInstruction(instruction),
      };
    }
    case DopplerLaunchHookV1Instruction.InitializeConfig: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: DopplerLaunchHookV1Instruction.InitializeConfig,
        ...parseInitializeConfigInstruction(instruction),
      };
    }
    case DopplerLaunchHookV1Instruction.RemoveCosigner: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: DopplerLaunchHookV1Instruction.RemoveCosigner,
        ...parseRemoveCosignerInstruction(instruction),
      };
    }
    case DopplerLaunchHookV1Instruction.SetAuthority: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: DopplerLaunchHookV1Instruction.SetAuthority,
        ...parseSetAuthorityInstruction(instruction),
      };
    }
    default:
      throw new SolanaError(
        SOLANA_ERROR__PROGRAM_CLIENTS__UNRECOGNIZED_INSTRUCTION_TYPE,
        {
          instructionType: instructionType as string,
          programName: 'dopplerLaunchHookV1',
        },
      );
  }
}

export type DopplerLaunchHookV1Plugin = {
  accounts: DopplerLaunchHookV1PluginAccounts;
  instructions: DopplerLaunchHookV1PluginInstructions;
};

export type DopplerLaunchHookV1PluginAccounts = {
  cosignerConfig: ReturnType<typeof getCosignerConfigCodec> &
    SelfFetchFunctions<CosignerConfigArgs, CosignerConfig>;
};

export type DopplerLaunchHookV1PluginInstructions = {
  addCosigner: (
    input: AddCosignerAsyncInput,
  ) => ReturnType<typeof getAddCosignerInstructionAsync> &
    SelfPlanAndSendFunctions;
  initializeConfig: (
    input: MakeOptional<InitializeConfigAsyncInput, 'payer'>,
  ) => ReturnType<typeof getInitializeConfigInstructionAsync> &
    SelfPlanAndSendFunctions;
  removeCosigner: (
    input: RemoveCosignerAsyncInput,
  ) => ReturnType<typeof getRemoveCosignerInstructionAsync> &
    SelfPlanAndSendFunctions;
  setAuthority: (
    input: SetAuthorityAsyncInput,
  ) => ReturnType<typeof getSetAuthorityInstructionAsync> &
    SelfPlanAndSendFunctions;
};

export type DopplerLaunchHookV1PluginRequirements = ClientWithRpc<
  GetAccountInfoApi & GetMultipleAccountsApi
> &
  ClientWithPayer &
  ClientWithTransactionPlanning &
  ClientWithTransactionSending;

export function dopplerLaunchHookV1Program() {
  return <T extends DopplerLaunchHookV1PluginRequirements>(client: T) => {
    return {
      ...client,
      dopplerLaunchHookV1: <DopplerLaunchHookV1Plugin>{
        accounts: {
          cosignerConfig: addSelfFetchFunctions(
            client,
            getCosignerConfigCodec(),
          ),
        },
        instructions: {
          addCosigner: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getAddCosignerInstructionAsync(input),
            ),
          initializeConfig: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getInitializeConfigInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          removeCosigner: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getRemoveCosignerInstructionAsync(input),
            ),
          setAuthority: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getSetAuthorityInstructionAsync(input),
            ),
        },
      },
    };
  };
}

type MakeOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;
